import React, { useMemo } from 'react'
import ReactApexChart from 'react-apexcharts'
import { CC_ESTEIRA_STEPS, formatBudgetMoney } from './budgetDashboardHelpers'
import '../../Financial/dashboard.scss'

const MAX_CC = 20

const BudgetVisaoGeralChart = ({ ccSummaries, graficoMetrica }) => {
  const step = CC_ESTEIRA_STEPS.find(s => s.key === graficoMetrica) || CC_ESTEIRA_STEPS[1]
  const metricKey = step.key
  const metricLabel = step.label
  const metricColor = step.color

  const chartItems = useMemo(() => (ccSummaries || [])
    .filter(row => Number(row[metricKey]) !== 0 || row.qtdItens > 0)
    .sort((a, b) => Math.abs(Number(b[metricKey])) - Math.abs(Number(a[metricKey])))
    .slice(0, MAX_CC), [ccSummaries, metricKey])

  if (!chartItems.length) {
    return <p className="text-muted mb-0">Nenhum dado para exibir no gráfico.</p>
  }

  const categories = chartItems.map(i => i.ccNome)
  const seriesData = chartItems.map(i => Number(i[metricKey] || 0))
  const chartHeight = Math.max(280, chartItems.length * 36 + 80)

  return (
    <div id="budget-visao-geral-chart" className="apex-charts" dir="ltr">
      <ReactApexChart
        type="bar"
        height={chartHeight}
        series={[{ name: metricLabel, data: seriesData }]}
        options={{
          chart: {
            type: 'bar',
            toolbar: { show: false },
            fontFamily: 'inherit',
          },
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: '65%',
            },
          },
          stroke: { width: 0 },
          dataLabels: { enabled: false },
          colors: [metricColor],
          xaxis: {
            categories,
            labels: {
              formatter: (v) => formatBudgetMoney(v),
              style: { fontSize: '11px' },
            },
          },
          yaxis: {
            labels: {
              style: { fontSize: '11px' },
              maxWidth: 220,
            },
          },
          tooltip: {
            y: {
              formatter: (v) => formatBudgetMoney(v),
            },
          },
          grid: { borderColor: '#f1f3f7' },
        }}
      />
    </div>
  )
}

export default BudgetVisaoGeralChart
